import React, { useState } from "react";
import "./DashboardStatisticsTable.scss";
import ContentStatisticsTable from "./ContentStatisticsTable/ContentStatisticsTable";
import HeaderStatisticsTable from "./HeaderStatisticsTable/HeaderStatisticsTable";
import { useSelector } from "react-redux";
import DownLoadXLSX from "./DownLoadXLSX/DownLoadXLSX";


const DashboardStatisticsTable = () => {

  const { headerList, filteredTableContent } = useSelector((state) => state.statisticsTable);


  const [sort, setSort] = useState({
    columnIndex: null,
    isAscendingSort: false
  })

  const sortTableContent = sort.columnIndex ? [...filteredTableContent.sort((item1, item2) => {
    if (sort.columnIndex === 7 || sort.columnIndex === 4 || sort.columnIndex === 6) {
      if (sort.isAscendingSort) {
        return Number(item2[sort.columnIndex]) - Number(item1[sort.columnIndex]);
      } else {
        return Number(item1[sort.columnIndex]) - Number(item2[sort.columnIndex]);
      }
    }
    if (sort.isAscendingSort) {
      return item2[sort.columnIndex].localeCompare(item1[sort.columnIndex]);
    } else {
      return item1[sort.columnIndex].localeCompare(item2[sort.columnIndex]);
    }
  })]
  : filteredTableContent

  const sortColumnHandler = (columnIndex, isAscendingSort) => {
    setSort({columnIndex, isAscendingSort : !isAscendingSort})
  }


  return (
    <div className={"dashboard-statistics-table-container"}>
      <div className={"dashboard-statistics-table-container__download-report-container"}>
        <DownLoadXLSX header={"statistics"} fileName={"statisticsFile"} table={{
          header: headerList,
          content: sortTableContent,
        }}/>
      </div>
      <div className={"dashboard-statistics-table-wrapper"}>
        <table className={"dashboard-statistics-table"}>
          <HeaderStatisticsTable sort={sort} sortColumnHandler={sortColumnHandler} />
          <ContentStatisticsTable tableContent={sortTableContent} />
        </table>
      </div>
      <div className={"dashboard-statistics-table__footer"}>Total: {filteredTableContent.length}</div>
    </div>
  );
};


export default DashboardStatisticsTable;
